/*
    CCIS Assessment Results
*/
Postlogin.CCISAssessmentResults = (function () {
    const init = function () {
        let language = $('#ccis-results-page-content-container').data('language');
        $('.assessment-results-table tbody tr').click(function () {
            window.location = $(this).find('a').attr('href');
        }).hover(function () {
            $(this).toggleClass('hover');
        });

        $('#change-language-btn').on('click', () => {
            const toHide = language === 'en' ? 'en' : 'es';
            language = language === 'en' ? 'es' : 'en';

            $(`.lang-${toHide}`).addClass('hidden');
            $(`.lang-${language}`).removeClass('hidden');
        });
    };

    return {
        init,
    };
}());
